<lib-custom-modal [title]="printClaimDetailsTitle"
  [modalSize]="'large'"
  (close)="hideModal()"
  #printModal>
  <ng-container class="app-modal-body">
    <form [formGroup]="printModalForm">
      <div class="border-top border-bottom py-3">{{ printModelLabel.MAKE_SELECTION_IN_REPORT }}</div>

      <div *ngIf="showPrintError"
        class="mt-2 mb-2">
        <lib-messaging [field]="messageFieldConfig"
          [messageStyle]="'form-message'"
          [message]="printError"></lib-messaging>
      </div>

      <div class="container-fluid py-3">
        <div class="row bg-secondary bg-opacity-10 p-4 mt-3 ">
          <div class="col-md-4">
            <huk-checkbox value="ClaimDemographics"
              formControlName="claimDemographicsCheck"
              (hukCheckboxClick)="checkboxCheck($event)">
              <strong>Claim Demographics</strong>
            </huk-checkbox>
          </div>
          <div class="col-md-4">
            <huk-checkbox value="CustomDemo"
              formControlName="customDemoCheck"
              (hukCheckboxClick)="checkboxCheck($event)">
              <strong>Custom Data</strong>
            </huk-checkbox>
          </div>
        </div>

        <div class="row bg-secondary bg-opacity-10 p-4 mt-3  align-items-center">
          <div class="col-md-4 mb-2 mb-md-0">
            <huk-checkbox value="financialMatrix"
              [checked]="financialMatrixFlag"
              formControlName="financialMatrixCheck"
              (hukCheckboxClick)="onFinancialMatrixCheck($event)">
              <strong>Financial Matrix</strong>
            </huk-checkbox>
          </div>

          <div class="col-md-3 mb-2 mb-md-0  fw-bold "
            [ngClass]="{'disabled-label': showPrintError}"
            style="color: #3A5A78;">
            {{ printModelLabel.VALUATION_DATE_LABEL }}
          </div>

          <div class="col-md-4">
            <app-treo-datepicker #datepicker
              [options]="options"
              (dateBlur)="handleDateChange($event)"></app-treo-datepicker>
          </div>
        </div>

        <div class="row bg-secondary bg-opacity-10 p-3 mt-3 ">

          <div class="col-md-12 mb-3">
            <huk-checkbox value="financialTransactionsCheck"
              formControlName="financialTransactionsCheck"
              [checked]="financialTransactionsFlag"
              (hukCheckboxClick)="onFinancialTransCheck($event)">
              <strong>Financial Transactions</strong>
            </huk-checkbox>
          </div>


          <div class="col-md-12 mb-4">
            <huk-radio-group horizontal
              formControlName="financialTransRadio">
              <huk-radio value="A">All</huk-radio>
              <huk-radio value="S">Refine
                Selection</huk-radio>
            </huk-radio-group>
          </div>


          <div *ngIf="isVisible && isRefineSectionVisible"
            class="col-md-12">

            <div class="mb-4">
              <label class="fw-bold d-block mb-2">{{ printModelLabel.PRINT_TRANSACTION_DATE }}</label>
              <div class="row g-2">
                <div class="col-md-4">
                  <lib-select [field]="transactionDateSelectConfig"
                    [group]="printModalForm"
                    (change)="handleBetweenTransactionDateType()"></lib-select>
                </div>
                <div class="col-md-4">
                  <app-treo-datepicker #datepickerOne
                    [options]="options"
                    (dateBlur)="transactionDateChangeHandler($event, printModalForm.controls['transactionDateSelect'], printModalForm.controls['transactionDate'])"></app-treo-datepicker>
                </div>
                <div *ngIf="showTransactionToDatePicker"
                  class="col-md-1 d-flex align-items-center justify-content-center pb-4">
                  <span>and</span>
                </div>
                <div *ngIf="showTransactionToDatePicker"
                  class="col-md-4">
                  <app-treo-datepicker #datepickerTwo
                    [options]="options"
                    (dateBlur)="transactionDateChangeHandler($event, printModalForm.controls['transactionDateSelect'], printModalForm.controls['transactionDate'], 'endDate')"></app-treo-datepicker>
                </div>
              </div>
            </div>


            <div class="mb-4">
              <label class="fw-bold d-block mb-2">{{ printModelLabel.PRINT_TRANSACTION_AMOUNT }}</label>
              <div class="row g-5">
                <div class="col-md-4">
                  <lib-select [field]="transactionAmountSelectConfig"
                    [group]="printModalForm"
                    (change)="handleBetweenAmountType($event)"></lib-select>


                </div>
                <div class="col-md-3">
                  <lib-input type="input"
                    [field]="transactionAmtField"
                    [group]="printModalForm"
                    (focusout)="changeInputFinance($event, 'transactionAmtField')"></lib-input>
                </div>
                <div *ngIf="showFinal"
                  class="col-md-1 d-flex align-items-center justify-content-center pb-4">
                  <span>and</span>
                </div>
                <div *ngIf="showFinal"
                  class="col-md-3">
                  <lib-input type="input"
                    [field]="transactionAmtEndField"
                    [group]="printModalForm"
                    (focusout)="changeInputEndFinance($event, 'transactionAmtEndField')"></lib-input>
                </div>
              </div>
              <div class="text-danger "
                *ngIf="showOperatorError">An operator must be selected.</div>
              <div class="text-danger "
                *ngIf="showBothAmountError">
                Two values are required.</div>
            </div>


            <div class="mb-4">
              <label class="fw-bold d-block mb-2">Financial Categories</label>
              <huk-select borderradius="classic"
                multiselect
                placeholder="Select Financial Categories"
                formControlName="financialCategories">
                <huk-option *ngFor="let item of finacialCategories"
                  value={{item.label}}>{{item.label}}</huk-option>
              </huk-select>
            </div>


            <div class="mb-4">
              <label class="fw-bold d-block mb-2">Financial Activity Type</label>
              <lib-select *ngIf="activityTypes.length"
                [field]="financialActivitySelectConfig"
                [group]="printModalForm"></lib-select>
            </div>
          </div>
        </div>

        <div class="row bg-secondary bg-opacity-10 p-4 mt-3">

          <div class="col-md-12 mb-3">
            <huk-checkbox value="claimNotes"
              [checked]="claimNotesFlag"
              formControlName="claimNotesCheck"
              (hukCheckboxClick)="onClaimNotesCheck($event)">
              <strong>Claim Notes</strong>
            </huk-checkbox>
          </div>


          <div class="col-md-12 mb-4">
            <huk-radio-group horizontal
              formControlName="claimNotesRadio">
              <huk-radio value="A">All</huk-radio>
              <huk-radio value="S">Note Date(s)</huk-radio>
            </huk-radio-group>
          </div>


          <div *ngIf="isVisible && isNoteDataVisible"
            class="col-md-12">
            <div class="row g-2">
              <div class="col-md-4 ms-5 ps-5">
                <lib-select [field]="claimNotesDateSelectConfig"
                  [group]="printModalForm"
                  (change)="handleBetweenClaimNotesDateType()"></lib-select>
              </div>
              <div class="col-md-4">
                <app-treo-datepicker #datepickerThree
                  [options]="options"
                  (dateBlur)="claimNotesDateChangeHandler($event, printModalForm.controls['noteDateSelect'], printModalForm.controls['noteDate'])"></app-treo-datepicker>
              </div>
              <div *ngIf="showClaimNotesDatePicker"
                class="col-md-1 d-flex align-items-center justify-content-center pb-4">
                <span>and</span>
              </div>
              <div *ngIf="showClaimNotesDatePicker"
                class="col-md-4 ms-5 ps-5">
                <app-treo-datepicker #datepickerFour
                  [options]="options"
                  (dateBlur)="claimNotesDateChangeHandler($event, printModalForm.controls['noteDateSelect'], printModalForm.controls['noteDate'], 'endDate')"></app-treo-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container class="border-top app-modal-footer">
    <div class="me-3 ms-3 float-start">
      <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
        class="btn btn-secondary"
        type="button"
        (click)="hideModal()">Cancel</button>
    </div>
    <div class="me-3 ms-3 float-end">
      <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
        type="button"
        [disabled]="showPrintError"
        class="btn btn-primary"
        (click)="savePrintDetails()">Print</button>
    </div>
  </ng-container>
</lib-custom-modal>